import { useEffect, useRef, useState } from "react";
import UserRecorderAudioVisualizer from "./UserRecorderAudioVisualizer";
import PauseCutoffSlider from "./PauseCutoffSlider";
import { useMicThresholdTrigger } from "../../../../../Util/hooks/useMicThreshholdTrigger";
import secondsToTimeString from "../../../../../Util/functions/secondsToTimeString";
import useRotatingMicRecorder from "../../../../../Util/hooks/useRotatingMicRecorder";

const UserAudioRecorder = ({
  onRecordingFinish,
  recordingStarted,
  isApplicationPaused,
  manualAudioStart,
  disableAutoSend,
  audioDeviceConfirmed,
}) => {
  const [isRecording, setIsRecording] = useState(false);

  const recorder = useRotatingMicRecorder({
    onStop: (mp3File) => {
      setIsRecording(false);
      onRecordingFinish(mp3File);
    },
    bufferDuration: 1000,
  });

  const micThresholdTrigger = useMicThresholdTrigger({
    threshold: 0.05,
    onTrigger: () => {
      recordingStarted();
      recorder.beginFinalRecording();
      setIsRecording(true);
    },
  });

  useEffect(() => {
    if (!audioDeviceConfirmed) return;

    let startRecordingTimeout = null;

    if (isApplicationPaused) {
      micThresholdTrigger.stop();
      if (recorder.isRecording) {
        recorder.disableRecorder();
      }
    } else {
      if (!manualAudioStart && !recorder.isRecording) {
        startRecordingTimeout = setTimeout(() => {
          recorder.start();
        }, 0);
      }
      if (!manualAudioStart && !micThresholdTrigger.isListening) {
        micThresholdTrigger.start();
      }
    }

    return () => {
      if (startRecordingTimeout) {
        clearTimeout(startRecordingTimeout);
      }
    };
  }, [isApplicationPaused, audioDeviceConfirmed]);

  return (
    <div className="speakingSectionUserInputWrapper">
      <div className="speakingSectionSpeakingVisualizerWrapper">
        {recorder.audioStream && isRecording && (
          <UserRecorderAudioVisualizer audioStream={recorder.audioStream} />
        )}
        {isRecording ? (
          <>
            <h2 className="speakingSectionSpeakingVisualizerTitle">
              Recording Duration
            </h2>
            <p className="speakingSectionSpeakingVisualizerText">
              {secondsToTimeString(recorder.durationInSeconds)}
            </p>
          </>
        ) : isApplicationPaused ? (
          <h2 className="speakingSectionSpeakingVisualizerTitle">
            Application Paused
          </h2>
        ) : manualAudioStart ? (
          <button
            className="speakingSectionButton"
            onClick={() => {
              recordingStarted();
              recorder.start();
            }}
          >
            Start Recording
          </button>
        ) : (
          <h2 className="speakingSectionSpeakingVisualizerTitle">
            Waiting To Detect User Audio
          </h2>
        )}
      </div>
      {disableAutoSend ? (
        isRecording ? (
          <button className="speakingSectionButton" onClick={recorder.stop}>
            Send Recording
          </button>
        ) : null
      ) : (
        <PauseCutoffSlider
          audioStream={recorder.audioStream}
          shouldListenForPause={isRecording}
          onFinish={() => recorder.stop()}
        />
      )}
    </div>
  );
};

export default UserAudioRecorder;
